import FeaturedSolutions from "../../../components/FeaturedSolutions";
import HorizontalLine from "../../../components/icons/HorizontalLine";
import LogoMini from "../../../components/icons/LogoMini";
import InfoGenesis from "../../../assets/img/Featured/tablet-info-genesis.png";
import Reserve from "../../../assets/img/Featured/app-reservations.png";
import "./index.scss";
import { useNavigate } from "react-router-dom";
import { useAnalytics } from "@popped/popshap-kiosk-components";
import { useCallback } from "react";
import { useData } from "../../../context/DataProvider";
import { Header } from "../../../components/Header";

const ExecutiveDiningPage = () => {
    const navigate = useNavigate();
    const { logEvent } = useAnalytics();
    const { addFlow, location } = useData()!;
    const _logEvent = useCallback(async (type: string, value: string, id?: string) => {
        await logEvent(type, value, { kiosk: location, id: id })
    }, [logEvent,location])
    return(
        <div className="page executiveDiningPage">
            <Header />
            <div className="page-header">Business & Industry Dining</div>
            <div className="text-wrapper">
                <div className="top">
                    <div className="topic-header">Executive Dining Room</div>
                    <HorizontalLine />
                </div>
                <div className="std-text">
                    Deliver memorable, efficient dining experiences in any 
                    venue. With guest data at their fingertips through 
                    Agilysys Reserve, servers can anticipate needs by 
                    understanding seating preferences, dietary 
                    restrictions, personal celebrations, and more to deliver 
                    personalized, memorable service.{'\n\n'}

                    InfoGenesis POS empowers guests to order in a 
                    simple conversational fashion, then forwards their 
                    orders to the kitchen for efficient preparation and 
                    staging so their meal is exactly the way they want it.
                </div>

            </div>

            <FeaturedSolutions>
                <div className="featured-item" onClick={()=>{
                    _logEvent('click', "Business & Industry Dining - Executive Dining Room", "InfoGenesis");
                    addFlow("InfoGenesis");
                    navigate("/solutions/info-genesis")}}>
                    <img src={InfoGenesis} alt="" />
                    <div className="item-head">
                        <LogoMini />
                        InfoGenesis
                    </div>
                </div>
                <div className="featured-item" onClick={()=>{
                    _logEvent('click', "Business & Industry Dining - Executive Dining Room", "Reserve");
                    addFlow("Reserve");
                    navigate("/solutions/reserve")}}>
                    <img src={Reserve} alt="" />
                    <div className="item-head">
                        <LogoMini />
                        Reserve
                    </div>
                </div>
            </FeaturedSolutions>
        </div>
    )
}
export default ExecutiveDiningPage;